"use client";
import TipsModal, { ModalProps } from "@/components/TipsModal";
import useDesktop from "@/hooks/useDesktop";
import { useSystemStore } from "@/stores/useSystemStore";
import { isPWAorAPK } from "@/utils";
import { server } from "@/utils/client";
import { isAndroid } from "@/utils/methods";
import clsx from "clsx";
import React from "react";
import dialogManage from "../manager";
import styles from "./index.module.scss";

interface AppInfoTypes {
    /**
     * 创建时间
     */
    created_at: number;
    /**
     * ID 编号
     */
    id: number;
    /**
     * 名称
     */
    name: string;
    /**
     * 文件大小
     */
    size: number;
    /**
     * 更新时间
     */
    updated_at: number;
    /**
     * 下载地址
     */
    url: string;
    /**
     * 版本号
     */
    version: string;
}

const getAppInfoApi = async () => {
    return server.request<AppInfoTypes>({
        url: "/v1/api/front/app/info",
        method: "POST",
    });
};

const InstallAPK = () => {
    const { downloadHandler } = useDesktop("components");
    const keyName = "InstallAPK";
    const [data, setData] = React.useState<AppInfoTypes | null>(null);
    const [errorType, setErrorType] = React.useState<number>(0);
    const { service } = useSystemStore((state) => ({
        isCollapse: state.isCollapse,
        setCollapse: state.setCollapse,
        service: state.service,
        show_free_game: state.show_free_game,
        show_again_game: state.show_again_game,
    }));
    const dialogRef = React.useRef<ModalProps>(null);
    React.useEffect(() => {
        let checkInterval: any = null;
        dialogManage.registerDialog({
            key: keyName,
            show() {
                window.isShowInstallAPK = true;
                dialogRef.current?.onOpen();
            },
            hide() {
                dialogRef.current?.onClose();
            },
        });
        if (isAndroid()) {
            getApkInfo();
        }

        if (!("serviceWorker" in navigator)) {
            setErrorType(1);
            return;
        }
        checkInterval = setInterval(() => {
            if (isPWAorAPK()) {
                closeClick();
                clearInterval(checkInterval);
            }
        }, 1000);
        return () => {
            clearInterval(checkInterval);
        };
    }, []);
    const getApkInfo = async () => {
        const res = await getAppInfoApi();
        if (res?.code === 200) {
            setData(res.data);
        }
    };

    const serviceUrl: string = React.useMemo(() => {
        if (!service) return "";
        const result = service.filter((item) => item.status === 1);
        return result[0]?.url || "";
    }, [service]);

    const closeClick = () => {
        window.isShowInstallAPK = false;
        dialogManage.hideDialog(keyName);
    };

    const doInstallPWA = async () => {
        if (!("serviceWorker" in navigator)) {
            setErrorType(1);
            return;
        }

        // window.checkIsInstallPwa();
        const canInstallPwa = sessionStorage.getItem("can_installPwa");
        if (canInstallPwa) {
            downloadHandler();
            return;
        }
        setErrorType(2);
    };

    return (
        <TipsModal
            position="bottom"
            ref={dialogRef}
            className={styles.dialog}
            getContainer={() => document?.querySelector("#app")}
            title={
                <div className="relative flex items-center p-[.1rem]">
                    <div className="w-[0.7rem]">
                        <img src="/home/777.webp" alt="" />
                    </div>
                    <div className="ml-[.1rem] text-left">
                        <div className="text-[.15rem] font-bold text-[#fff]">bcwin777.com</div>
                        <div className={styles.desc}>
                            Mais b&#39;nus e beneficios distribuidos.Interface do sistemae
                            velocideade de acesso otimizadas
                        </div>
                    </div>
                    <div className="absolute right-[.1rem] top-[.1rem] flex items-center">
                        {serviceUrl && (
                            <a href={serviceUrl} target="_blank">
                                <i className="iconfont icon-xiaoxi-zhihui text-[.2rem] font-normal text-[#fff]"></i>
                            </a>
                        )}

                        <div className={styles.close} onClick={closeClick}>
                            <i className="iconfont icon-guanbi text-[.12rem] font-normal text-[#fff]"></i>
                        </div>
                    </div>
                </div>
            }
            useClose={false}
        >
            <div className={styles.container}>
                <div className="py-[.1rem] text-center text-[.16rem] font-bold">
                    Uma versão melhor o aguarda!
                </div>
                <div className="text-center">
                    <div className={styles.icon}>
                        <img src="/home/i1.webp" alt="" />
                    </div>
                    <span className={styles.text}>
                        Descubra a nova versäo cheia de recursos incriveis.
                    </span>
                </div>
                <div className="text-center">
                    <div className={styles.icon}>
                        <img src="/home/i2.webp" alt="" />
                    </div>
                    <span className={styles.text}>
                        Mais jogos adicionados para expandir suas opções.
                    </span>
                </div>
                <div className="text-center">
                    <div className={styles.icon}>
                        <img src="/home/i3.webp" alt="" />
                    </div>
                    <span className={styles.text}>
                        Bõnus exclusivos e beneficios imperdiveis para você.
                    </span>
                </div>
                <div className="text-center">
                    <div className={styles.icon}>
                        <img src="/home/i4.webp" alt="" />
                    </div>
                    <span className={styles.text}>
                        Navegação otimizada para uma experiência mais rápida e fluida.
                    </span>
                </div>
                <div className={clsx(styles.text, "mt-[.1rem]")}>{}</div>
                {isAndroid() && (
                    <a className={styles.installBtn} href={data?.url} download={data?.name}>
                        <img src="/home/download.webp" alt="" />
                        <div className="text-[.18rem] font-black">Ganhe R$10</div>
                    </a>
                )}
                {!isAndroid() && (
                    <div className={styles.installBtn} onClick={doInstallPWA}>
                        <img src="/home/download.webp" alt="" />
                        <div className="text-[.18rem] font-black">Ganhe R$10</div>
                    </div>
                )}
                {errorType !== 0 && (
                    <div className="text-center text-[.1rem] leading-[1] text-[red]">
                        {errorType === 2 &&
                            "Se você já tiver o aplicativo instalado, jogue no aplicativo. Se não estiver instalado, tente atualizar a interface ou fechar a guia para voltar a instalar."}
                        {errorType === 1 &&
                            "O navegador atual não suporta a instalação de PWA, por favor, use a nova versão do navegador Chrome"}
                    </div>
                )}

                <div className="py-[.05rem] text-[.12rem] text-[#11de68]">
                    Insialacão de um aplicativo Android:
                </div>
                <div className="py-[.05rem] text-[.13rem]">
                    1.Instale o aplicativo clicando no botão acima
                </div>
                <div className="py-[.05rem] text-[.13rem]">
                    2. Permita que o aplicativo seja instalado e aguarde pacientemente.
                </div>
                <div className="py-[.05rem] text-[.13rem]">
                    3. A instalação será concluda em 5 segundos.
                </div>
                <div className={styles.intro}>
                    <div>
                        <i className={clsx("iconfont icon-jurassic_warning", styles.warn)}></i>
                        <span className="text-[.14rem] text-[#11de68]">Aviso amigável:</span>
                    </div>
                    <div className="text-[.1rem]">
                        Este aplicativo passou pela certificacāo de seguranca do Google.
                    </div>
                </div>
            </div>
        </TipsModal>
    );
};

export default InstallAPK;
